import { createAnalyticsAdapter, createPromotionCodeAdapter } from "@func-core/core/data/adapters";
import { useResultStore } from "@func-core/core/data/repositories/result-repository";
import { rollbar, RollbarLogArgument } from "@utils/rollbar";

let adapter: ReturnType<typeof createAnalyticsAdapter> | null = null;

const getAdapter = () => {
  if (!adapter) {
    adapter = createAnalyticsAdapter();
  }

  return adapter;
};

export const initializeAnalyticsService = async (): Promise<void> => {
  try {
    await getAdapter().initializeAnalytics();
  } catch (error) {
    rollbar.error("Failed to initialize Analytics", error as RollbarLogArgument);
  }
};

export const trackEventService = (
  event: string,
  properties: Record<string, unknown> = {}
): void => {
  getAdapter().trackEvent(event, properties);
};

export const trackPageService = (
  pageName: string,
  properties: Record<string, unknown> = {}
): void => {
  const promotionCodeAdapter = createPromotionCodeAdapter();
  const promotionCode = promotionCodeAdapter.getPromotionCode();

  const result = useResultStore.getState().result;

  const couponProperties = {
    coupon: promotionCode ? promotionCode : undefined,
  };

  const leadProperties = {
    leadAgeInDays: result?.leadAgeInDays ?? undefined,
  };

  getAdapter().trackEvent("Viewed", {
    path: pageName,
    ...couponProperties,
    ...leadProperties,
    ...properties,
  });
};
